import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CollectionType } from 'src/domains/casino/types/types';
import { CarouselPromo } from 'src/domains/layouts/webview/components/homePageCarouselPromos/carouselPromo/CarouselPromo';
import { HeadlineCarousel } from 'src/domains/layouts/webview/components/headlineCarousel/HeadlineCarousel';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface CasinoPromotionsPropsType {
    collection: CollectionType;
}

export const CasinoPromotions = observer('CasinoPromotions', (props: CasinoPromotionsPropsType): JSX.Element => {
    const { collection } = props;
    const common = useCommon();
    const { hasCarouselPromo, hasHeadlinePromo } = ConfigComponents.get(common).config;

    return (
        <>
            {hasCarouselPromo === true && <CarouselPromo modeType={collection} />}
            {hasHeadlinePromo === true && <HeadlineCarousel route={collection} />}
        </>
    );
});
